import { fromFetch } from 'rxjs/fetch';
import { FleetJwtAuthHeaders } from '../../models/fleet-jwt-auth-headers';
import { PagedCollectionParams } from '../../models/paged-collection-params';
import { requiredHeaders } from '../../models/required-headers';
import { selectData } from '../../utils/select-data';
import { fleetEnvironment } from './fleet-environment';
import { configurationProfilePagedCollectionSchema } from './schemas/configuration-profile-paged-collection.schema';

export function getConfigurationProfiles(params?: PagedCollectionParams) {
  const requestUrl = `${fleetEnvironment.configurationProfilesUrl}?${
    params ? params.urlParams : ''
  }`;
  return fromFetch(
    new Request(requestUrl, {
      method: 'GET',
      headers: {
        ...requiredHeaders,
        ...new FleetJwtAuthHeaders(),
      },
    })
  ).pipe(selectData(configurationProfilePagedCollectionSchema));
}
